<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:25:51 +0800
 * @最后修改时间: 2021-08-23 16:53:08
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\InternalUse\editAttendance.vue
 -->
<!--
 * $Description: 
 * $Author: Betway
 * $LastEditors: BetWay
 * $Date: 2020年03月13日 10:18:19 +0800
 * $LastEditTime: 2020年03月13日 10:24:16 +0800
 * $FilePath: /src/components/ESS-Admin/LeaveAdmin/LeaveType.vue
 -->
<template>
  <ContentLayout
    pad="0"
    :title="$t('label_essweb_attendanceInternal_form_viewTitle')"
    widthClass="max-1000"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row align="center" justify="start" class="white lighten-5">
              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="
                    $getDateTime(AttendanceData.utc_att_date, 'YYYY/MM/DD')
                  "
                  :prefix="$t('label_essweb_attendanceInternal_form_dateLabel')"
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  single-line
                  readonly
                  :suffix="AttendanceData.staff_code"
                  :prefix="
                    $t('label_essweb_attendanceInternal_form_staffIdLabel')
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="12">
                <v-text-field
                  readonly
                  :suffix="
                    $getCommonLangValue(AttendanceData.schedule_shift_name)
                  "
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_scheduleShiftNameLabel'
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="
                    $getDateTime(
                      AttendanceData.schedule_start_utc_time,
                      'HH:mm'
                    )
                  "
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_scheduleStartTimeLabel'
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="
                    getDays(
                      AttendanceData.schedule_end_utc_time,
                      AttendanceData.schedule_start_utc_time
                    ) +
                    $getDateTime(AttendanceData.schedule_end_utc_time, 'HH:mm')
                  "
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_scheduleEndTimeLabel'
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="12">
                <v-text-field
                  readonly
                  :suffix="
                    $getCommonLangValue(AttendanceData.official_shift_name)
                  "
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_officailShiftNameLabel'
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="
                    $getDateTime(
                      AttendanceData.official_start_utc_time,
                      'HH:mm'
                    )
                  "
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_officialStartTimeLabel'
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="
                    getDays(
                      AttendanceData.official_end_utc_time,
                      AttendanceData.official_start_utc_time
                    ) +
                    $getDateTime(AttendanceData.official_end_utc_time, 'HH:mm')
                  "
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_officialEndTimeLabel'
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="12">
                <v-text-field
                  readonly
                  :suffix="
                    AttendanceData.Status == '1'
                      ? $t('label_essweb_system_status_onLabel')
                      : $t('label_essweb_system_status_offLabel')
                  "
                  :prefix="
                    $t('label_essweb_attendanceInternal_form_statusLabel')
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="
                    Number(AttendanceData.is_onduty)
                      ? $t('label_essweb_system_label_trueLabel')
                      : $t('label_essweb_system_label_falseLabel')
                  "
                  :prefix="
                    $t('label_essweb_attendanceInternal_form_isOnDutyLabel')
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="
                    Number(AttendanceData.is_locked)
                      ? $t('label_essweb_system_label_trueLabel')
                      : $t('label_essweb_system_label_falseLabel')
                  "
                  :prefix="
                    $t('label_essweb_attendanceInternal_form_isLockedLabel')
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="12">
                <v-sheet class="text--primary pl-1">{{
                  $t("label_essweb_attendanceInternal_form_tagLabel")
                }}</v-sheet>
                <v-text-field
                  readonly
                  :prefix="
                    (Number(AttendanceData.is_late)
                      ? $t('label_essweb_system_tag_label_lateLabel')
                      : '') +
                    (Number(AttendanceData.is_early_leave)
                      ? ',' +
                        $t('label_essweb_system_tag_label_earlyLeaveLabel')
                      : '') +
                    (Number(AttendanceData.is_ot)
                      ? ',' + $t('label_essweb_system_tag_label_otLabel')
                      : '') +
                    (Number(AttendanceData.is_absense)
                      ? ',' + $t('label_essweb_system_tag_label_absenseLabel')
                      : '') +
                    (Number(AttendanceData.is_on_leave)
                      ? ',' + $t('label_essweb_system_tag_label_leaveLabel')
                      : '') +
                    (Number(AttendanceData.is_early_leave)
                      ? ',' +
                        $t('label_essweb_system_tag_label_earlyLeaveLabel')
                      : '') +
                    (Number(AttendanceData.is_holiday)
                      ? ',' + $t('label_essweb_system_tag_label_holidayLabel')
                      : '')
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_isPunchInRequiredLabel'
                    )
                  "
                  readonly
                  :suffix="
                    Number(AttendanceData.is_punch_in_required)
                      ? $t('label_essweb_system_label_trueLabel')
                      : $t('label_essweb_system_label_falseLabel')
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_isPunchOutRequiredLabel'
                    )
                  "
                  readonly
                  :suffix="
                    Number(AttendanceData.is_punch_out_required)
                      ? $t('label_essweb_system_label_trueLabel')
                      : $t('label_essweb_system_label_falseLabel')
                  "
                  dense
                ></v-text-field>
              </v-col>
              <!--  -->
              <!-- <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="AttendanceData.utc_att_time_zone"
                  prefix="Date Time Zone"
                  dense
                ></v-text-field>
              </v-col>

              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="AttendanceData.schedule_start_time_zone"
                  prefix="Schedule Start Time Zone"
                  dense
                ></v-text-field>
              </v-col>

              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="AttendanceData.schedule_end_time_zone"
                  prefix="Schedule End Time Zone"
                  dense
                ></v-text-field>
              </v-col>

              <v-col md="6"></v-col>

              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="AttendanceData.official_start_time_zone"
                  prefix="Official Start Time Zone"
                  dense
                ></v-text-field>
              </v-col>

              <v-col md="6"></v-col>

              <v-col md="6">
                <v-text-field
                  readonly
                  :suffix="AttendanceData.official_end_time_zone"
                  prefix="Official End Time Zone"
                  dense
                ></v-text-field>
              </v-col>-->

              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_actualPunchInIdLabel'
                    )
                  "
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_actualPunchInTimetimeZoneLabel'
                    )
                  "
                  readonly
                  :suffix="
                    $getUtcTime(
                      AttendanceData.actual_punch_in_utc_datetime,
                      AttendanceData.actual_punch_in_time_zone
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_actualPunchOutIdLabel'
                    )
                  "
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_actualPunchOutTimetimeZoneLabel'
                    )
                  "
                  readonly
                  :suffix="
                    $getUtcTime(
                      AttendanceData.actual_punch_out_utc_datetime,
                      AttendanceData.actual_punch_out_time_zone
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_modifiPunchInIdLabel'
                    )
                  "
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_modifiPunchInTimetimeZoneLabel'
                    )
                  "
                  readonly
                  :suffix="
                    $getUtcTime(
                      AttendanceData.modified_punch_in_utc_datetime,
                      AttendanceData.modified_punch_in_time_zone
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_modifiPunchOutIdLabel'
                    )
                  "
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_modifiPunchOutTimetimeZoneLabel'
                    )
                  "
                  readonly
                  :suffix="
                    $getUtcTime(
                      AttendanceData.modified_punch_out_utc_datetime,
                      AttendanceData.modified_punch_out_time_zone
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_officialPunchInIdLabel'
                    )
                  "
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_officialPunchInTimetimeZoneLabel'
                    )
                  "
                  readonly
                  :suffix="
                    $getUtcTime(
                      AttendanceData.official_punch_in_utc_datetime,
                      AttendanceData.official_punch_in_time_zone
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_officialPunchOutIdLabel'
                    )
                  "
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_officialPunchOutTimetimeZoneLabel'
                    )
                  "
                  readonly
                  :suffix="
                    $getUtcTime(
                      AttendanceData.official_punch_out_utc_datetime,
                      AttendanceData.official_punch_out_time_zone
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="12">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_isPunchCriteriaMatchedLabel'
                    )
                  "
                  readonly
                  :suffix="
                    Number(AttendanceData.is_punch_criteria_matched)
                      ? $t('label_essweb_system_label_trueLabel')
                      : $t('label_essweb_system_label_falseLabel')
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_actualWorkingMinutesLabel'
                    )
                  "
                  readonly
                  :suffix="AttendanceData.actual_working_minutes.toString()"
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_officialworkingMinutesLabel'
                    )
                  "
                  readonly
                  :suffix="AttendanceData.official_working_minutes.toString()"
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_shiftPropertyGroupLabel'
                    )
                  "
                  readonly
                  :suffix="
                    $getCommonLangValue(
                      AttendanceData.shift_property_group_name
                    )
                  "
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  :prefix="
                    $t(
                      'label_essweb_attendanceInternal_form_relatedApplicationsLabel'
                    )
                  "
                  readonly
                  :suffix="AttendanceData.application_uuid"
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="12">
                <v-text-field
                  :prefix="
                    $t('label_essweb_attendanceInternal_form_remarkLabel')
                  "
                  readonly
                  :suffix="AttendanceData.remarks"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-card elevation="0" class="elevation-1 pa-0 ma-auto">
            <v-card-text class="px-3 white fill-height from_content">
              <v-data-table
                :headers="headers"
                :items="desserts"
                :single-expand="true"
                hide-default-header
                :expanded.sync="expanded"
                show-expand
                expand-icon="mdi-unfold-less-horizontal"
                hide-default-footer
                :page.sync="page"
                :fixed-header="true"
                :elevation="0"
                item-key="uuid"
                :items-per-page="$tableSetting.perPageSize"
                @page-count="$tableSetting.pageCount = $event"
              >
                <template v-slot:no-data>
                  <noContent />
                </template>
                <template v-slot:item.name="{ item }">
                  <div class="mt-4 mb-4">
                    {{ $getCommonLangValue(item.event_type_name) }}
                  </div>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td
                    :colspan="headers.length"
                    style="border: none"
                    class="white"
                  >
                    <v-form>
                      <v-row>
                        <v-col md="12">
                          <v-text-field
                            readonly
                            :suffix="item.staff_code"
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_staffIdLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="12">
                          <v-text-field
                            readonly
                            :suffix="
                              $getCommonLangValue(item.schedule_shift_name)
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_scheduleShiftNameLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="
                              $getDateTime(
                                item.schedule_start_utc_time,
                                'HH:mm'
                              )
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_scheduleStartTimeLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="
                              getDays(
                                item.schedule_end_utc_time,
                                item.schedule_start_utc_time
                              ) +
                              $getDateTime(item.schedule_end_utc_time, 'HH:mm')
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_scheduleEndTimeLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="12">
                          <v-text-field
                            readonly
                            :suffix="
                              $getCommonLangValue(item.official_shift_name)
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_officailShiftNameLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="
                              $getDateTime(
                                item.official_start_utc_time,
                                'HH:mm'
                              )
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_officialStartTimeLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="
                              getDays(
                                item.official_end_utc_time,
                                item.official_start_utc_time
                              ) +
                              $getDateTime(item.official_end_utc_time, 'HH:mm')
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_officialEndTimeLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="item.total_minutes.toString()"
                            :prefix="
                              $t('label_essweb_shift_list_totalMinutesLabel')
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6"></v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="$getCommonLangValue(item.event_type_name)"
                            :prefix="
                              $t(
                                'label_essweb_eventType_list_eventTypeNameLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="item.event_type_uuid"
                            :prefix="
                              $t(
                                'label_essweb_eventType_list_eventTypeNameLabel'
                              ) + 'ID'
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="
                              Number(item.is_onduty)
                                ? $t('label_essweb_system_label_trueLabel')
                                : $t('label_essweb_system_label_falseLabel')
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_isOnDutyLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="
                              Number(item.is_locked)
                                ? $t('label_essweb_system_label_trueLabel')
                                : $t('label_essweb_system_label_falseLabel')
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_isLockedLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="
                              Number(item.is_punch_in_required)
                                ? $t('label_essweb_system_label_trueLabel')
                                : $t('label_essweb_system_label_falseLabel')
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_isPunchInRequiredLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            readonly
                            :suffix="
                              Number(item.is_punch_out_required)
                                ? $t('label_essweb_system_label_trueLabel')
                                : $t('label_essweb_system_label_falseLabel')
                            "
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_isPunchOutRequiredLabel'
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_actualPunchInIdLabel'
                              )
                            "
                            readonly
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_actualPunchInTimetimeZoneLabel'
                              )
                            "
                            readonly
                            :suffix="
                              $getUtcTime(
                                item.actual_punch_in_utc_datetime,
                                item.actual_punch_in_time_zone
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_actualPunchOutIdLabel'
                              )
                            "
                            readonly
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_actualPunchOutTimetimeZoneLabel'
                              )
                            "
                            readonly
                            :suffix="
                              $getUtcTime(
                                item.actual_punch_out_utc_datetime,
                                item.actual_punch_out_time_zone
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_modifiPunchInIdLabel'
                              )
                            "
                            readonly
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_modifiPunchInTimetimeZoneLabel'
                              )
                            "
                            readonly
                            :suffix="
                              $getUtcTime(
                                item.modified_punch_in_utc_datetime,
                                item.modified_punch_in_time_zone
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_modifiPunchOutIdLabel'
                              )
                            "
                            readonly
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_modifiPunchOutTimetimeZoneLabel'
                              )
                            "
                            readonly
                            :suffix="
                              $getUtcTime(
                                item.modified_punch_out_utc_datetime,
                                item.modified_punch_out_time_zone
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_officialPunchInIdLabel'
                              )
                            "
                            readonly
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_officialPunchInTimetimeZoneLabel'
                              )
                            "
                            readonly
                            :suffix="
                              $getUtcTime(
                                item.official_punch_in_utc_datetime,
                                item.official_punch_in_time_zone
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_officialPunchOutIdLabel'
                              )
                            "
                            readonly
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_officialPunchOutTimetimeZoneLabel'
                              )
                            "
                            readonly
                            :suffix="
                              $getUtcTime(
                                item.official_punch_out_utc_datetime,
                                item.official_punch_out_time_zone
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_isPunchCriteriaMatchedLabel'
                              )
                            "
                            readonly
                            :suffix="
                              Number(item.is_punch_criteria_matched)
                                ? $t('label_essweb_system_label_trueLabel')
                                : $t('label_essweb_system_label_falseLabel')
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6"></v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_actualWorkingMinutesLabel'
                              )
                            "
                            readonly
                            :suffix="item.actual_working_minutes.toString()"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_list_officialWorkingMinutesLabel'
                              )
                            "
                            readonly
                            :suffix="item.official_working_minutes.toString()"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_lateMinutesLabel'
                              )
                            "
                            readonly
                            :suffix="item.late_minutes.toString()"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_earlyLeaveMinutesLabel'
                              )
                            "
                            readonly
                            :suffix="item.early_leave_minutes.toString()"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_originalLeaderLabel'
                              )
                            "
                            readonly
                            :suffix="item.original_leader_staff_uuid"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_partTimeLeaderLabel'
                              )
                            "
                            readonly
                            :suffix="item.parttime_learder_staff_uuid"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="12">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_shiftPropertyGroupLabel'
                              )
                            "
                            readonly
                            :suffix="
                              $getCommonLangValue(
                                item.event_property_group_name
                              )
                            "
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col md="12">
                          <v-text-field
                            :prefix="
                              $t(
                                'label_essweb_attendanceInternal_form_remarkLabel'
                              )
                            "
                            readonly
                            :suffix="item.remarks"
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </template>
      </Taber>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editAttendance",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      curTab: "tab-1",
      taber: [
        "label_essweb_attendanceInternal_form_tag_masterLabel",
        "label_essweb_attendanceInternal_form_tag_detailLabel",
      ],
      iSEdited: false,
      page: 1,
      AttendanceData: {
        attendance_master_id: "",
        uuid: "",
        utc_att_date: "",
        utc_att_time_zone: "",
        staff_uuid: "",
        staff_code: "",
        official_shift_name: "",
        schedule_shift_uuid: "",
        schedule_start_utc_time: "",
        schedule_start_time_zone: "",
        schedule_end_utc_time: "",
        schedule_end_time_zone: "",
        official_shift_uuid: "",
        official_shift_name: "",
        official_start_utc_time: "",
        official_start_time_zone: "",
        official_end_utc_time: "",
        official_end_time_zone: "",
        status_uuid: "",
        is_punch_in_required: "",
        is_punch_out_required: "",
        actual_punch_in_uuid: "",
        actual_punch_out_uuid: "",
        actual_punch_in_utc_datetime: "",
        actual_punch_in_time_zone: "",
        actual_punch_out_utc_datetime: "",
        actual_punch_out_time_zone: "",
        modified_flow_task_uuid: "",
        modified_punch_in_utc_datetime: "",
        modified_punch_in_time_zone: "",
        modified_punch_out_utc_datetime: "",
        modified_punch_out_time_zone: "",
        official_punch_in_utc_datetime: "",
        official_punch_in_time_zone: "",
        official_punch_out_utc_datetime: "",
        official_punch_out_time_zone: "",
        actual_working_minutes: "",
        official_working_minutes: "",
        is_late: "",
        is_early_leave: "",
        is_ot: "",
        is_absense: "",
        is_on_leave: "",
        leave_type_uuid: "",
        is_holiday: "",
        holiday_uuid: "",
        is_onduty: "",
        is_pre_locked: "",
        is_locked: "",
        shift_property_group_uuid: "",
        org_level_uuid: "",
        remarks: "",
        application_uuid: "",
        is_punch_criteria_matched: "",
      },
      headers: [
        { text: "Name", value: "name", sortable: false },
        { text: "", value: "data-table-expand", align: "end", sortable: false },
      ],
      desserts: [],
      expanded: [],
    };
  },
  mounted() {
    this.getDetail();
    this.getList();
  },
  methods: {
    toBack: function () {
      if (this.iSEdited) {
        this.iSEdited = false;
      } else {
        this.$router.back();
      }
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: "/attendance-master/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.AttendanceData = res.data;
      });
    },
    getDays(start, end) {
      start = new Date(start);
      end = new Date(end);
      if (!start || !end) return "";
      if (isNaN(start) || isNaN(end)) return "";
      let day = parseInt((Number(start) - Number(end)) / (24 * 60 * 60 * 1000));
      return day > 0 ? "(+" + day + ")" : "";
    },
    getList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_detail",
        url: "/attendance-detail/get-list/",
        data: {
          master_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.desserts = res.data;
      });
    },
  },
};
</script>